<!-- TODO: this template seems to belong to component in vcexam -->
<uib-accordion close-others="oneAtATime" data-hook="currentexams-component">
    <div uib-accordion-group ng-repeat="exam in vm.examinations | filter: {active: true}  | orderBy: '-_id'"
         data-exam-type="{{exam.template.type}}"
         is-open="vm.status.isOpen[$index]">
        <!-- exam header -->
        <uib-accordion-heading>
            <div class="row">
                <div class="col-xs-12 col-sm-8">
                    <h4>
                        <span ng-show="vm.status.isOpen[$index]" data-hook="hideexam"
                              ng-click="vm.status.isOpen[$index] = !status.isOpen[$index]"><i
                                class="fa fa-caret-up"></i></span>
                        <span ng-hide="vm.status.isOpen[$index]" data-hook="showexam"
                              ng-click="vm.status.isOpen[$index] = !status.isOpen[$index]"><i
                                class="fa fa-caret-down"></i></span>
                        {{exam.template.displayname}}&nbsp;
                        <span style="color: #999999; font-size: smaller"
                              ng-show="exam.open === true && (exam.template.loadfiles === true || exam.template.shareid !== '')">(autom. Bildimport aktiv)</span>
                    </h4>
                </div>
                <div class="col-xs-12 col-sm-4" style="text-align: right">
                    <h4>
                        <!-- print btn radio toggle -->
                        <a class="btn-group">
                            <a class="btn btn-success btn-sm" ng-model="exam.print" data-hook="printexam"
                               uib-tooltip="Drucken" uib-btn-radio="true"
                               style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; "
                               ng-click="$event.stopPropagation(); vm.setprint(exam, true); "><i
                                    class="fa fa-print"></i></a><!-- do not remove this comment, css sucks
                  --><a class="btn btn-danger btn-sm" ng-model="exam.print" uib-tooltip="Nicht drucken"
                        uib-btn-radio="false"
                        style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; "
                        ng-click="$event.stopPropagation(); vm.setprint(exam, false); "><i class="fa fa-ban"></i></a>
                        </a>
                        <!-- finish exam button button-->
                        <a class="btn btn-warning btn-sm"
                           data-hook="finishexam"
                           ng-click="$event.stopPropagation(); vm.finishExam(exam); "
                           ng-hide="exam.open === false"
                           uib-tooltip="Untersuchung abschließen">
                            <i class="fa fa-flag-checkered"></i>
                        </a>
                        <!-- textansicht button-->
                        <a class="btn btn-primary btn-sm"
                           data-hook="viewexam"
                           ng-click="$event.stopPropagation(); editexam[$index] = false; "
                           ng-hide="vm.showview(exam.open, editexam[$index])"
                           uib-tooltip="Textansicht">
                            <i class="fa fa-table"></i>
                        </a>
                        <!-- Edit button -->
                        <a class="btn btn-primary btn-sm"
                           data-hook="editexam"
                           ng-click="$event.stopPropagation(); editexam[$index] = true;"
                           ng-hide="vm.showeditor(exam.open, editexam[$index])"
                           uib-tooltip="Editieren">
                            <i class="fa fa-edit"></i>
                        </a>
                        <!-- PDF ansicht button-->
                        <a class="btn btn-info btn-sm"
                           data-hook="viewpdfexam"
                           ng-click="$event.stopPropagation()"
                           href="{{vm.examPreviewUrl(exam._id, exam.patientid)}}"
                           target="_blank" uib-tooltip="PDF Vorschau"><i class="fa fa-eye"></i></a>
                        <!-- TODO: stress test exam identifcation by $index when deleting adding adding exams -->
                        <!-- delete button-->
                        <a class="btn btn-danger btn-sm"
                           data-hook="deleteexam"
                           ng-click="vm.deleteExam(exam)" uib-tooltip="Entfernen">
                            <i class="fa fa-remove"></i></a>
                    </h4>
                </div>
            </div>
        </uib-accordion-heading>
        <!-- exam data -->
        <div class="row">
            <examview exam="exam" ng-if="vm.showview(exam.open, editexam[$index])"></examview>
            <div class="spacer-sides" ng-if="vm.showeditor(exam.open, editexam[$index])">
                <exameditor exam="exam"></exameditor>
            </div>
        </div>
    </div>  <!-- exam in openConsult.examinations -->
</uib-accordion>